import Vue from "vue";

import axios from "axios";

export default class Axios {
  constructor({ baseURL, bearerToken, headers = {} }) {
    if (bearerToken)
      axios.defaults.headers.common["Authorization"] = `Bearer ${bearerToken}`;

    axios.defaults.headers.common = {
      ...headers,
      ...axios.defaults.headers.common
    };

    this.instance = axios.create({ baseURL });
  }

  call(path, method, data) {
    let request = {
      method: method,
      url: path
    };

    if (method === "GET") request.params = data;
    else request.data = data;

    return this.instance.request(request);
  }
}
